import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="clipboard"

// Used in: list partials for school main contact, coach, default and 'default part' and school contact, school, user, temporary school rb files
// Purpose: copy a given source target text to the cliboard and toggle the corresponding icon

export default class extends Controller {
  static targets = ['source', 'copySvg', 'copyCompleteSvg'];
  connect() {}
  copy() {
    const text = this.sourceTarget.innerText;
    navigator.clipboard.writeText(text);
    this.toggleSvgs();
    setTimeout(() => {
      this.toggleSvgs();
    }, '550');
  }
  toggleSvgs() {
    if (!this.hasCopySvgTarget || !this.hasCopyCompleteSvgTarget) return;
    this.copySvgTarget.classList.toggle('hidden');
    this.copyCompleteSvgTarget.classList.toggle('hidden');
  }
}
